<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="Course-Main-Tab" class="data-list-container">
    <div slot="no-body" class="tabs-container  pb-6">
    <div class="tab-text">
      <!-- 1 -->
      <div class="vx-row">
        <div class="vx-col lg:w-1/3 w-full">
          <p>{{ $t('InternalCourseCode') }}</p>
            <vs-input v-model="courseModel.CourseCode" class=" w-full" name="CourseCode" />
            <span class="text-danger text-sm" v-show="errors.has('CourseCode')">{{ errors.first('CourseCode') }}</span>
          </div>
          <!-- <v-select :options="Providers" v-model="courseModel.ProviderID" @input="initValues" class="vx-col lg:w-1/3 w-full mt-5" label="Name">
      <template slot="option" slot-scope="option" >
          <span  :class="option.icon"></span>
        {{ option.Name }}
    </template>
    </v-select> -->
          <div class="vx-col lg:w-1/3 w-full">
            <p>{{ $t('Provider') }}</p>
            <v-select label="Name" name="Provider" class="mw-full" v-model="courseModel.ProviderID" :options="Providers"
              :reduce="ID => ID.ID" />
          </div>
          <!-- <vs-select    autocomplete class="vx-col lg:w-1/3 w-full mt-5" label="Provider" v-model="courseModel.ProviderID">
                        <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in Providers" />
                      </vs-select> -->

          <div class="vx-col lg:w-1/3 w-full">
            <p>{{ $t('Location') }}</p>
            <vs-input v-model="courseModel.Location" class="w-full" name="Location" />
            <span class="text-danger text-sm" v-show="errors.has('Location')">{{ errors.first('Location') }}</span>
          </div>
        </div>
        <!-- 2 -->
        <div class="vx-row">

          <div class="vx-col lg:w-1/3 w-full ">
            <br />
            <p>{{ $t('CourseName') }}</p>
            <vs-input v-model="courseModel.Name" class="w-full" name="name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>

          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('Language') }}</p>
            <v-select label="Name" class="w-full" multiple autocomplete v-model="courseModel.languages"
              :options="getLanguage" :reduce="ID => ID.ID" />
          </div>
          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>ICAO Code</p>
            <vs-input v-model="courseModel.ICAOCode" class=" w-full" name="ICAOCode" />
          </div>


        </div>
        <!-- 3 -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('AreaOfStudy') }}</p>
            <v-select label="Name" class=" w-full" multiple autocomplete v-model="courseModel.areaOfStudies"
              :options="getCourseAreaOfStudyList" :reduce="ID => ID.ID" />
          </div>
          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('IndustrySector') }}</p>
            <v-select label="Name" class=" w-full" multiple autocomplete v-model="courseModel.industrySectors"
              :options="getindustrySector" :reduce="ID => ID.ID" />
          </div>
          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('Category') }}</p>
            <v-select label="Name" class="w-full" v-model="courseModel.CourseCategoryID" :options="getCourseCategory"
              :reduce="ID => ID.ID" />
          </div>

        </div>
        <!-- 4 -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('CourseType') }}</p>
            <v-select label="Name" class="w-full" multiple v-model="courseModel.modes" :options="getCourseType"
              :reduce="mode => mode.ID" />
          </div>


          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('TrainingStrategy') }}</p>
            <v-select label="Name" class="w-full" multiple autocomplete v-model="courseModel.trainingStrategy"
              :options="getTrainingStrategies" :reduce="ID => ID.ID" />
          </div>


          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('Level') }}</p>
            <v-select label="Name" class=" w-full" v-model="courseModel.CourseLevelID" :options="getCourseLevel"
              :reduce="ID => ID.ID" />
          </div>

        </div>
        <!-- 5 -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('PassDegreeIn') }} %</p>
            <vs-input type="number" min=50 max=100 v-model="courseModel.PassDegree" class=" w-full" name="PassDegree"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('PassDegree')">{{ errors.first('PassDegree') }}</span>
          </div>
          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('ExcellentDegree') }}</p>
            <vs-input v-model="courseModel.ExcellentDegree" class="w-full" name="ExcellentDegree"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('ExcellentDegree')">{{ errors.first('ExcellentDegree')
            }}</span>
          </div>
          <div class="vx-col lg:w-1/3 w-full">
            <br />
            <p>{{ $t('Color') }}</p>
            <vs-input id="colorPicer" class="vx-col w-full" type="color" name="favcolor"
              v-model="courseModel.ColorCode" />
          </div>
        </div>

        <!-- 6 -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 w-full">
            <br />
            <p>{{ $t('DurationInHour') }}</p>
            <vs-input v-model="courseModel.CourseDurationInHours" type="number" class="w-full" name="Duration"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Duration')">{{ errors.first('Duration') }}</span>
          </div>
          <div class="vx-col lg:w-1/4 w-full">
            <br />
            <p>{{ $t('Days') }}</p>
            <vs-input v-model="courseModel.CourseDays" type="number" class="w-full" name="Days" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Days')">{{ errors.first('Days') }}</span>
          </div>
          <div class="vx-col lg:w-1/4 w-full">
            <br />
            <p>{{ $t('PopulationList') }}e</p>
            <v-select label="Name" class="w-full" multiple autocomplete v-model="courseModel.populationList"
              :options="getPopulationList" :reduce="ID => ID.ID" />
          </div>
          <div class="vx-col lg:w-1/4 w-full">
            <br />
            <p>{{ $t('CommaSeperated') }}</p>
            <vs-input v-model="courseModel.ShouldAttend" class="w-full" name="attend" />
          </div>

        </div>
        <!-- 7 -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full">
            <br />
            <p>{{ $t('IntroductionAbout') }}</p>
            <quill-editor v-model="courseModel.ICAOCategory" class="w-full" name="ICAOCategory" />
          </div>

          <div class="vx-col lg:w-1/2 w-full">
            <br />
            <p>{{ $t('DocsAndHand') }}</p>
            <!-- <vs-input  v-model="courseModel.Documentation"  class="w-full" name="Documentation"  /> -->
            <v-select label="Name" class="w-full" multiple autocomplete v-model="courseModel.documentations"
              :options="Documentations" :reduce="ID => ID.ID" />
          </div>



        </div>
        <!-- 8 -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full">
            <br />
            <p>{{ $t('References') }}</p>
            <quill-editor v-model="courseModel.References" class="w-full" name="References" />
          </div>



          <div class="vx-col lg:w-1/2 w-full">
            <br />
            <p>{{ $t('Prerequisite') }}</p>
            <quill-editor v-model="courseModel.Prerequisite" class="w-full" name="Prerequisite" />
          </div>

        </div>
        <!-- 9 -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full">
            <br />
            <p>{{ $t('Objectives') }}</p>

            <quill-editor v-model="courseModel.Objectives" />
          </div>
          <div class="vx-col lg:w-1/2 w-full">
            <br />
            <p> {{ $t('CourseImage') }}</p>
            <vs-card title="icon">

              <template v-if="courseModel.ImageUrl">

                <!-- Image Container -->
                <div class="img-container w-64 mx-auto flex items-center justify-center">
                  <img :src="baseURL + courseModel.ImageUrl" alt="img" class="responsive">
                </div>
              </template>

              <!-- Image upload Buttons -->
              <div class="modify-img flex justify-between mt-5">
                <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                <vs-button class="mr-4" type="flat"
                  @click="$refs.updateImgInput.click()">{{ $t('UpdateImage') }}</vs-button>
                <vs-button type="flat" color="#999" @click="courseModel.ImageUrl = null">{{ $t('RemoveImage') }}</vs-button>
              </div>
            </vs-card>
          </div>
        </div>

        <div class="vx-row mt-5">

          <div class="vx-col lg:w-1/2 w-full">
            <vs-switch success v-model="courseModel.IsPublish">
              <template #off>
                {{ $t('NotPublished') }}
              </template>
              <template #on>
                {{ $t('Published') }}
              </template>
            </vs-switch>

          </div>

          <vs-card class="vx-col lg:w-1/2 w-full">

            <h6>{{ $t('InstructorsOfThatCourse') }}</h6>
            <h7 v-for="item in courseModel.InstructorCourses" :key="item.ID">, {{ item.Instructor.Name }}</h7>
          </vs-card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

import vSelect from 'vue-select'
import moduleCourseCategory from "@/store/settings/courseCategory/moduleCourseCategory.js";
import moduleCourseType from "@/store/settings/courseType/moduleCourseType.js";
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleCourseLevel from "@/store/settings/courseLevel/moduleCourseLevel.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
import moduleCourseAreaOfStudy from "@/store/settings/courseAreaOfStudy/moduleCourseAreaOfStudy.js";
import modulePopulationList from "@/store/settings/populationList/modulePopulationList.js";
import moduleTrainingStrategy from "@/store/settings/trainingStrategy/moduleTrainingStrategy.js";
import moduleProvider from "@/store/settings/provider/moduleProvider.js";
import moduleDocumentation from "@/store/settings/documentation/moduleDocumentation.js";
import { domain, mainSetting } from '@/gloabelConstant.js';
import axios from "@/axios.js"
export default {
  components: {
    vSelect,
    quillEditor
  },
  props: {
    courseModel: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      isMounted: false,
      baseURL: domain,
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      uploadUrl: domain + "API/Course/UploadFile",
    };
  },
  computed: {
    Providers() {
      return this.$store.state.ProviderList.providers;
    },
    Documentations() {
      return this.$store.state.DocumentationList.Documentations;
    },
    getCourseCategory() {
      return this.$store.state.courseCategoryList.courseCategories;
    },
    getCourseType() {
      debugger
      return this.$store.state.courseTypeList.courseTypes;
    },
    getCourseLevel() {
      return this.$store.state.courseLevelList.courseLevels;
    },
    getLanguage() {
      return this.$store.state.languageList.languages;
    },

    getindustrySector() {
      return this.$store.state.industrySectorList.industrySectors;
    },
    getCourseAreaOfStudyList() {
      return this.$store.state.courseAreaOfStudyList.courseAreaOfStudies;
    },
    getPopulationList() {
      return this.$store.state.populationListList.populationLists;
    },
    getTrainingStrategies() {
      return this.$store.state.trainingStrategyList.trainingStrategies;
    }
  },

  methods: {
    updateCurrImg(input) {

      if (input.target.files && input.target.files[0]) {
        let data = new FormData()
        data.append('file', input.target.files[0])

        axios.post(this.uploadUrl, data)
          .then((response) => {
            this.courseModel.ImageUrl = response.data;
          })
      }
    },
  },

  created() {
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }

    if (!moduleCourseCategory.isRegistered) {
      this.$store.registerModule("courseCategoryList", moduleCourseCategory);
      moduleCourseCategory.isRegistered = true;
    }
    if (!moduleCourseType.isRegistered) {
      this.$store.registerModule("courseTypeList", moduleCourseType);
      moduleCourseType.isRegistered = true;
    }
    if (!moduleCourseLevel.isRegistered) {
      this.$store.registerModule("courseLevelList", moduleCourseLevel);
      moduleCourseLevel.isRegistered = true;
    }
    if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
    if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
    if (!moduleCourseAreaOfStudy.isRegistered) {
      this.$store.registerModule("courseAreaOfStudyList", moduleCourseAreaOfStudy);
      moduleCourseAreaOfStudy.isRegistered = true;
    }
    if (!modulePopulationList.isRegistered) {
      this.$store.registerModule("populationListList", modulePopulationList);
      modulePopulationList.isRegistered = true;
    }
    if (!moduleTrainingStrategy.isRegistered) {
      this.$store.registerModule("trainingStrategyList", moduleTrainingStrategy);
      moduleTrainingStrategy.isRegistered = true;
    }
    if (!moduleProvider.isRegistered) {
      this.$store.registerModule("ProviderList", moduleProvider);
      moduleProvider.isRegistered = true;
    }
    if (!moduleDocumentation.isRegistered) {
      this.$store.registerModule("DocumentationList", moduleDocumentation);
      moduleDocumentation.isRegistered = true;
    }
    this.$store.dispatch("DocumentationList/fetchDataListItems");
    this.$store.dispatch("ProviderList/fetchDataListItems");
    this.$store.dispatch("trainingStrategyList/fetchDataListItems");
    this.$store.dispatch("populationListList/fetchDataListItems");
    this.$store.dispatch("courseAreaOfStudyList/fetchDataListItems");
    this.$store.dispatch("industrySectorList/fetchDataListItems");
    this.$store.dispatch("languageList/fetchDataListItems");
    this.$store.dispatch("courseLevelList/fetchDataListItems");
    this.$store.dispatch("courseTypeList/fetchDataListItems");
    this.$store.dispatch("courseCategoryList/fetchDataListItems");

  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

input[type="color" i] {
  height: 35px !important;
}

#colorPicer .vs-input--input.normal {
  padding: 0.2rem
}
</style>
